<crm-multi-select
  #multiSelectComponent
  [options]="deals"
  [(selectedItems)]="_selectedDeals"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="searchDeal($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="75"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [placeholder]="placeholder"
  filterBy="name,contragent.name">
  <ng-template
    #selectedItemsTemplate
    let-deals="items">
    <ng-container *ngFor="let deal of deals; last as isLast">
      {{ toDeal(deal)?.name }}{{ isLast ? '' : ', ' }}
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-deal="item">
    <ng-container *ngIf="toDeal(deal) as deal">
      <div class="w-full flex justify-content-between align-items-center white-space-normal gap-2">
        <div>
          <p class="font-bold">{{ deal.name }}</p>
          <p class="font-medium">{{ deal.contragent?.name }}</p>
          <p class="font-bold text-green-500">{{ deal.amount | number: '.0-0' }}</p>
        </div>
        <div
          *ngIf="isShowStatus"
          class="white-space-nowrap">
          <crm-status-label
            *ngIf="deal.status"
            [name]="deal.status.name"
            [color]="deal.status.color"></crm-status-label>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
